import { createContext } from 'react';

export const ModalsContext = createContext({
  showAssociationModal: false,
  setShowAssociationModal: (isOpen: boolean) => {},
});
